// src/components/ErrorBoundary.jsx
import React, { Component } from 'react';
import { ErrorContext, ERROR_TYPES } from '../context/ErrorContext';

class ErrorBoundary extends Component {
  static contextType = ErrorContext;
  
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  
  static getDerivedStateFromError(error) {
    // Actualiza el estado para mostrar la UI alternativa
    return { hasError: true };
  }
  
  componentDidCatch(error, errorInfo) {
    // Reportar el error al contexto global
    const { addError } = this.context;
    addError(
      'Ha ocurrido un error durante el renderizado', 
      ERROR_TYPES.UNKNOWN,
      'react-rendering',
      { error, errorInfo }
    );
  }
  
  render() {
    if (this.state.hasError) {
      // Puedes personalizar la UI de error
      return this.props.fallback || (
        <div className="p-4 m-4 bg-red-50 border border-red-200 rounded-md" role="alert">
          <h2 className="text-lg font-medium text-red-700 mb-2">Algo salió mal</h2>
          <p className="text-sm text-red-600">
            Se ha producido un error inesperado. Intenta recargar la página.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700"
          >
            Recargar página
          </button>
        </div>
      );
    }
    
    return this.props.children;
  }
}

export default ErrorBoundary;